import { createHashHistory as createHistory } from 'history';

export default createHistory();
